import React from 'react';
import { Link } from 'react-router-dom';
import { FiFacebook, FiInstagram, FiTwitter, FiLinkedin, FiMapPin, FiPhone, FiClock } from 'react-icons/fi';
import { FaPinterestP, FaTiktok } from 'react-icons/fa';

const data = {
  facebookLink: 'https://web.facebook.com/p/Ceylanthro-100090762638873/?_rdc=1&_rdr#',
  linkedinLink: 'https://www.linkedin.com/company/ceylanthro-by-ceylonese-nature-food-products-pvt-ltd/about/',
  twitterLink: 'https://x.com/ceylanthro',
  instaLink: 'https://www.instagram.com/ceylanthro',
  pinterestLink: 'https://kr.pinterest.com/Ceylanthro/',
  tiktokLink: 'https://www.tiktok.com/@_ceylanthro',
  about: {
    story: '/aboutus',
    sourcing: '/aboutus',
    sustainability: '/aboutus'
  },
  company: {
    name: 'Ceylanthro',
    description: 'Pure Ceylon Nature — Authentic wellness products sustainably sourced from Sri Lanka.',
    logo: 'https://media-manager-c.questera.ai/greta-media/29d79c4109d1c19c2e75790b8e50872c9a33c9d5ce79f6f43f60effe48b91ada6d4fe9244bdd866a6b5eb503d1d2a9a7/images/aW1hZ2UvcG5n/154eff52dc1f1c00de3fe58bdd4b1694.png',
  },
};

const socialLinks = [
  { icon: FiFacebook, label: 'Facebook', href: data.facebookLink },
  { icon: FiLinkedin, label: 'LinkedIn', href: data.linkedinLink },
  { icon: FiTwitter, label: 'X (Twitter)', href: data.twitterLink },
  { icon: FiInstagram, label: 'Instagram', href: data.instaLink },
  { icon: FaPinterestP, label: 'Pinterest', href: data.pinterestLink },
  { icon: FaTiktok, label: 'TikTok', href: data.tiktokLink }
];

const aboutLinks = [
  { text: 'Our Story', href: data.about.story },
  { text: 'Sourcing & Quality', href: data.about.sourcing },
  { text: 'Sustainability', href: data.about.sustainability },
  { text: 'Blog', href: '/blog' }
];

const serviceLinks = [
  { text: 'Ceylon Cinnamon', href: '/shop?search=cinnamon' },
  { text: 'Herbal Teas', href: '/shop?search=tea' },
  { text: 'Virgin Coconut Oils', href: '/shop?search=oil' },
  { text: 'Wellness & Body Care', href: '/shop?search=wellness' },
  { text: 'Natural Snacks', href: '/shop?search=coconut' }
];

export default function FooterGlow() {
  return (
    <div className="relative z-10 w-full overflow-hidden pt-6 pb-6 sm:pt-8 sm:pb-8">
      {/* Background Glow Elements */}
      <div className="pointer-events-none absolute top-0 left-1/2 z-0 h-full w-full -translate-x-1/2 select-none">
        <div className="absolute top-0 left-1/4 h-48 w-48 sm:h-72 sm:w-72 rounded-full bg-brand-gold/20 blur-3xl"></div>
        <div className="absolute right-1/4 bottom-0 h-56 w-56 sm:h-80 sm:w-80 rounded-full bg-brand-sage/20 blur-3xl"></div>
      </div>

      {/* Main Glassmorphism Container */}
      <div className="relative mx-3 sm:mx-6 md:mx-8 max-w-7xl lg:mx-auto flex flex-col gap-6 sm:gap-8 md:gap-10 rounded-2xl sm:rounded-3xl md:rounded-[2rem] px-4 py-8 sm:px-6 sm:py-10 md:px-10 md:py-10 bg-white/50 backdrop-blur-xl border border-white/60 shadow-[0_20px_50px_-15px_rgba(0,0,0,0.05)] my-3 sm:my-4 md:my-6">

        {/* Top Row: Brand + Nav */}
        <div className="flex flex-col lg:flex-row justify-between items-center lg:items-start gap-8">

          {/* Left Side: Brand & Social */}
          <div className="flex flex-col items-center lg:items-start w-full lg:w-1/4 text-center lg:text-left">
            <Link to="/" className="mb-4 flex items-center justify-center lg:justify-start">
              <img
                src={data.company.logo}
                alt="Ceylanthro"
                className="h-12 sm:h-14 md:h-16 object-contain drop-shadow-sm transition-all duration-300"
              />
            </Link>
            <p className="text-brand-darkSage/70 mb-4 max-w-xs leading-relaxed text-xs sm:text-sm">{data.company.description}</p>
            <div className="flex flex-wrap gap-2 sm:gap-2.5 text-brand-darkSage/60 justify-center lg:justify-start">
              {socialLinks.map(({ icon: Icon, label, href }) => (
                <a
                  key={label}
                  href={href}
                  aria-label={label}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-brand-gold hover:-translate-y-1 transition-all duration-300 bg-white/50 p-2 sm:p-2.5 rounded-full shadow-sm border border-white"
                >
                  <Icon className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Right Side: Navigation Links */}
          <nav className="flex-1 grid grid-cols-2 sm:grid-cols-4 gap-6 sm:gap-4 md:gap-8 w-full pt-4 lg:pt-0">

            {/* Column 1: About */}
            <div className="flex flex-col items-center sm:items-start text-center sm:text-left">
              <div className="mb-3 sm:mb-5 text-[10px] sm:text-xs font-bold tracking-[0.2em] text-brand-darkSage uppercase font-serif">About Us</div>
              <ul className="space-y-2 sm:space-y-3">
                {aboutLinks.map(({ text, href }) => (
                  <li key={text}><Link to={href} className="text-xs sm:text-sm text-brand-darkSage/70 hover:text-brand-gold transition-colors">{text}</Link></li>
                ))}
              </ul>
            </div>

            {/* Column 2: Shop */}
            <div className="flex flex-col items-center sm:items-start text-center sm:text-left">
              <div className="mb-3 sm:mb-5 text-[10px] sm:text-xs font-bold tracking-[0.2em] text-brand-darkSage uppercase font-serif">Shop</div>
              <ul className="space-y-2 sm:space-y-3">
                {serviceLinks.map(({ text, href }) => (
                  <li key={text}><Link to={href} className="text-xs sm:text-sm text-brand-darkSage/70 hover:text-brand-gold transition-colors">{text}</Link></li>
                ))}
              </ul>
            </div>

            {/* Column 3: Shipping / Tracking */}
            <div className="flex flex-col items-center sm:items-start text-center sm:text-left">
              <div className="mb-3 sm:mb-5 text-[10px] sm:text-xs font-bold tracking-[0.2em] text-brand-darkSage uppercase font-serif">Shipping</div>
              <ul className="space-y-2 sm:space-y-3">
                <li><Link to="/track" className="text-xs sm:text-sm text-brand-darkSage/70 hover:text-brand-gold transition-colors">Track My Order</Link></li>
              </ul>
            </div>

            {/* Column 4: Legal */}
            <div className="flex flex-col items-center sm:items-start text-center sm:text-left">
              <div className="mb-3 sm:mb-5 text-[10px] sm:text-xs font-bold tracking-[0.2em] text-brand-darkSage uppercase font-serif">Legal</div>
              <ul className="space-y-2 sm:space-y-3">
                <li><Link to="/page/terms-and-conditions" className="text-xs sm:text-sm text-brand-darkSage/70 hover:text-brand-gold transition-colors">Terms & Conditions</Link></li>
                <li><Link to="/page/privacy-policy" className="text-xs sm:text-sm text-brand-darkSage/70 hover:text-brand-gold transition-colors">Privacy Policy</Link></li>
              </ul>
            </div>
          </nav>
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-brand-darkSage/10" />

        {/* Bottom Row: 4-Column Info Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-8">

          {/* Address */}
          <div className="flex flex-col items-center sm:items-start text-center sm:text-left">
            <div className="flex items-center gap-2 mb-3">
              <FiMapPin className="text-brand-gold w-4 h-4 flex-shrink-0" />
              <span className="text-[10px] sm:text-xs font-bold tracking-[0.15em] text-brand-darkSage uppercase">Address</span>
            </div>
            <p className="text-[11px] sm:text-xs text-brand-darkSage/70 leading-relaxed">
              Ceylonese Nature Food Products<br />
              (Pvt) Ltd, No. 2 1/1,<br />
              Military Junction, Main Street,<br />
              Dharga Town, Aluthgama,<br />
              12090, Sri Lanka.
            </p>
          </div>

          {/* Corporate Office */}
          <div className="flex flex-col items-center sm:items-start text-center sm:text-left">
            <div className="flex items-center gap-2 mb-3">
              <FiMapPin className="text-brand-gold w-4 h-4 flex-shrink-0" />
              <span className="text-[10px] sm:text-xs font-bold tracking-[0.15em] text-brand-darkSage uppercase">Corporate Office</span>
            </div>
            <p className="text-[11px] sm:text-xs text-brand-darkSage/70 leading-relaxed">
              133 New Bridge Road<br />
              #14-03 Chinatown Point<br />
              Singapore 059413
            </p>
          </div>

          {/* Company Info & Service Hours */}
          <div className="flex flex-col items-center sm:items-start text-center sm:text-left">
            <div className="flex items-center gap-2 mb-3">
              <FiClock className="text-brand-gold w-4 h-4 flex-shrink-0" />
              <span className="text-[10px] sm:text-xs font-bold tracking-[0.15em] text-brand-darkSage uppercase">Service Hours</span>
            </div>
            <p className="text-[11px] sm:text-xs text-brand-darkSage font-semibold mb-1 sm:mb-2">
              Ceylonese Nature Food Products (Pvt) Ltd
            </p>
            <p className="text-[11px] sm:text-xs text-brand-darkSage/60 mb-1 sm:mb-2">Established in 2021</p>
            <p className="text-[11px] sm:text-xs text-brand-darkSage/70">
              08:30 AM to 5:30 PM daily<br />
              (GMT+5:30)
            </p>
          </div>

          {/* Enquiries */}
          <div className="flex flex-col items-center sm:items-start text-center sm:text-left">
            <div className="flex items-center gap-2 mb-3">
              <FiPhone className="text-brand-gold w-4 h-4 flex-shrink-0" />
              <span className="text-[10px] sm:text-xs font-bold tracking-[0.15em] text-brand-darkSage uppercase">Enquiries</span>
            </div>
            <div className="space-y-3">
              <div>
                <p className="text-[11px] sm:text-xs font-bold text-brand-darkSage mb-1">B2B Enquiries</p>
                <p className="text-[11px] sm:text-xs text-brand-darkSage/70">
                  Mobile: +94 77 446 8660<br />
                  <a href="mailto:sales@ceylanthro.com" className="hover:text-brand-gold transition-colors">sales@ceylanthro.com</a>
                </p>
              </div>
              <div>
                <p className="text-[11px] sm:text-xs font-bold text-brand-darkSage mb-1">General Enquiries</p>
                <p className="text-[11px] sm:text-xs text-brand-darkSage/70">
                  Mobile: +94 77 446 8660<br />
                  <a href="mailto:info@ceylanthro.com" className="hover:text-brand-gold transition-colors">info@ceylanthro.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Copyright Bar */}
      <div className="text-brand-darkSage/60 relative z-10 mt-4 sm:mt-6 flex flex-col items-center justify-center text-center text-[10px] sm:text-[11px] gap-3 px-4">
        <span>&copy; {new Date().getFullYear()} {data.company.name}. All rights reserved.</span>
      </div>
    </div>
  );
}